var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"content-licence-agreement-modal","scrollable":"","title":"Content Licence Agreement","size":"xl","hide-footer":""}},[_c(`${_vm.capitalizeFirstLetter(_vm.locale)}ContentLicenceAgreementContent`,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }